import type { PrefetchContext, PrefetchedDataProps } from 'src/shared/prefetch';

import { prefetchImpactStoryPageDataFromApi, useImpactStoryPageDataFromApi } from './pageData';

export type ImpactStoryPagePrefetchedContext = Readonly<{
	pageData: NonNullable<Parameters<typeof useImpactStoryPageDataFromApi>[0]>;
}>;

export type ImpactStoryPageCombinedState = ReturnType<typeof useImpactStoryPageDataFromApi>;

export function usePageContext(
	slug: string,
	prefetchedData?: ImpactStoryPagePrefetchedContext,
): ImpactStoryPageCombinedState {
	return useImpactStoryPageDataFromApi(prefetchedData?.pageData, slug);
}

export async function prefetchPageContext(
	slug: string,
	context: PrefetchContext,
): Promise<ImpactStoryPagePrefetchedContext> {
	const pageData = await prefetchImpactStoryPageDataFromApi(context, slug);

	return { pageData };
}

export type ImpactStoryPagePrefetchedDataProps = PrefetchedDataProps<ImpactStoryPagePrefetchedContext>;
